var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightPersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#00A6CA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 11.7437C11.6567 11.7437 11.3624 11.6213 11.1177 11.3765C10.8729 11.1317 10.7505 10.8374 10.7505 10.4937C10.7505 10.1499 10.8729 9.85563 11.1177 9.61084C11.3624 9.36605 11.6567 9.24365 12.0005 9.24365C12.3442 9.24365 12.6385 9.36605 12.8833 9.61084C13.1281 9.85563 13.2505 10.1499 13.2505 10.4937C13.2505 10.8374 13.1281 11.1317 12.8833 11.3765C12.6385 11.6213 12.3442 11.7437 12.0005 11.7437ZM9.0838 14.7566V14.0706C9.0838 13.8986 9.13387 13.7377 9.23401 13.5878C9.33422 13.438 9.46897 13.3217 9.63828 13.2389C10.0315 13.0503 10.4249 12.9089 10.8186 12.8146C11.2123 12.7204 11.6062 12.6732 12.0005 12.6732C12.3947 12.6732 12.7887 12.7204 13.1823 12.8146C13.576 12.9089 13.9695 13.0503 14.3627 13.2389C14.532 13.3217 14.6667 13.438 14.7669 13.5878C14.8671 13.7377 14.9171 13.8986 14.9171 14.0706V14.7566H9.0838Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightPersonIcon);
export default __webpack_public_path__ + "static/media/light-person-icon.976eb752599000db75359319743786cd.svg";
export { ForwardRef as ReactComponent };